import React from 'react';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { Button } from '@mui/material';

import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useState } from 'react';

export function DialogoOpcao({ opcoes, selecaoOpcao, onClose, salvarLista }) {
  const [opcoesSelecionadas, setOpcoesSelecionadas] = useState([]);
  const [scroll, setScroll] = React.useState('paper');

  const selecionados = (e, opcao) => {
    const checked = e.target.checked;

    if (checked) {
      opcao.selected = true;
      setOpcoesSelecionadas([...opcoesSelecionadas, opcao]);
    } else {
      opcao.selected = false;
      setOpcoesSelecionadas(opcoesSelecionadas.filter((e) => e !== opcao));
    }
  };

  const salvarSelecionados = () => {
    const opcoesChecked = opcoes.filter((opcao) => opcao.selected === true);

    salvarLista(opcoesChecked);
  };
  // console.log('opcoesSelecionadas', opcoes);
  return (
    <>
      <Dialog
        open={true}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">Selecione as opções</DialogTitle>
        <DialogContent dividers={scroll === 'paper'}>
          <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
            <List sx={{ pt: 0 }}>
              {opcoes.map((opcao, key) => (
                <ListItem button key={key}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        defaultChecked={opcao.selected}
                        onChange={(e) => selecionados(e, opcao)}
                      />
                    }
                    label={opcao.desc}
                  />
                </ListItem>
              ))}
            </List>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={() => onClose()}>
            Cancelar
          </Button>
          <Button variant="outlined" onClick={() => salvarSelecionados()}>
            Concluir
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export function DialogoCaixa({
  texto,
  titulo,
  caixaTextoOpen,
  confirmar,
  cancelar,
}) {
  return (
    <div>
      <Dialog
        open={caixaTextoOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{titulo}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {texto}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => cancelar()}>Cancelar</Button>
          <Button onClick={() => confirmar()} autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
